module.exports = __webpack_public_path__ + "img/BackstageAngel.45d89a60.jpg";